import { render, staticRenderFns } from "./CompraIngredienta.vue?vue&type=template&id=170c0534&"
import script from "./CompraIngredienta.vue?vue&type=script&lang=js&"
export * from "./CompraIngredienta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports